import $axios from '~/plugins/axios';

import { Api, GetCampaignParams, CampaignLight } from '~/api';
import { buildModule } from '../utils';
import { createDict, Dict } from '~/helpers';

const api = $axios as Api;

type LazyLoadingParams = Omit<GetCampaignParams, 'limit' | 'offset'>;

export default buildModule()
	.withState({
		campaignById: {} as Dict<CampaignLight>,
		orderedIds: [] as number[],
		params: {} as LazyLoadingParams,
	})
	.withGetters({
		items: (state) => state.orderedIds.map(id => state.campaignById[id]),
		byId: (state) => (id: number) => state.campaignById[id],
	})
	.withMutations({
		RESET (state, params: LazyLoadingParams = {}) {
			state.params = params;
			state.orderedIds = [];
		},
		APPEND_CAMPAIGNS (state, campaigns: CampaignLight[]) {
			state.campaignById = { ...state.campaignById, ...createDict(campaigns, ({ id }) => id) };
			state.orderedIds = Array.from(new Set([ ...state.orderedIds, ...campaigns.map((campaign) => campaign.id) ]));
		},
		SET_CAMPAIGNS (state, campaigns: CampaignLight[]) {
			state.campaignById = { ...state.campaignById, ...createDict(campaigns, ({ id }) => id) };
		},
	})
	.withActions({
		async getMore ({ state, commit }, limit: number) {
			const params: GetCampaignParams = { ...state.params, limit, offset: state.orderedIds.length };
			const { data } = await api.get('/campaign', { params });

			commit('APPEND_CAMPAIGNS', data.payload);
		},
		async prefetchCampaigns ({ commit }, campaignIds: number[]) {
			const getRequests = campaignIds.map((id) => api.get(`/campaign/${ id }`));
			const responses = await Promise.all(getRequests);

			const campaigns = responses.map((resp) => resp.data.payload as unknown as CampaignLight);
			commit('SET_CAMPAIGNS', campaigns);
		},
		async getCampaign ({ commit }, campaignId: number) {
			const { data } = await api.get(`/campaign/${ campaignId }`);

			commit('SET_CAMPAIGNS', [ data.payload as unknown as CampaignLight ]);
		},
		resetParams ({ state, commit }, params: LazyLoadingParams = {}) {
			commit('RESET', { ...state.params, ...params });
		},
	});


